export const DALLAS_BACKGROUND_COLOR_OPTIONS = [
  'dark',
  'darkGray',
  'lightGray',
  'light',
  'brand',
  'lightBrand',
  'disabled',
  'info',
  'infoAlt',
  'success',
  'error',
  'warning',
  'infoStrong',
  'successStrong',
  'errorStrong',
  'warningStrong',
] as const;

export type DallasBackgroundColor =
  (typeof DALLAS_BACKGROUND_COLOR_OPTIONS)[number];

export const DALLAS_BACKGROUND_COLOR_CLASSNAME_SEGMENTS: Readonly<
  Record<DallasBackgroundColor, string>
> = {
  dark: 'dark',
  darkGray: 'dark-gray',
  lightGray: 'light-gray',
  light: 'light',
  brand: 'brand',
  lightBrand: 'light-brand',
  disabled: 'disabled',
  info: 'info',
  infoAlt: 'info-alt',
  success: 'success',
  error: 'error',
  warning: 'warning',
  infoStrong: 'info-strong',
  successStrong: 'success-strong',
  errorStrong: 'error-strong',
  warningStrong: 'warning-strong',
};
